export default __webpack_public_path__ + "static/media/sports03.15789ffa.jpg";